import { useMemo } from 'react';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { MaximumDropzoneTextLength } from '../atom.dropzone-content/context.js';
import { MaximumTileTextLength } from '../atom.tile/context.js';
import { FacitContainer } from './organism.facit-container.js';
import { InputContainer } from './organism.input-container.js';
import { PrintContainer } from './organism.print-container.js';
import { jsx } from 'react/jsx-runtime';

function GroupTask(props) {
  const context = useTaskContext();
  const pageContext = usePageContext();
  const maximumTileTextLength = useMemo(() => props.task.content.reduce((acc, curr) => {
    switch (curr.type) {
      case "Audio":
        return Math.max(acc, curr.title.length);
      case "Image":
        return Math.max(acc, curr.title.length);
      case "Text":
        return Math.max(acc, curr.text.length);
    }
  }, 0), [props.task.content]);
  const maximumDropzoneTextLength = useMemo(() => props.task.groups.reduce((acc, curr) => {
    switch (curr.type) {
      case "Text":
        return Math.max(acc, curr.text.length);
      default:
        return acc;
    }
  }, 0), [props.task.groups]);
  const content = (() => {
    if (pageContext === "print") {
      return /*#__PURE__*/jsx(PrintContainer, {
        ...props
      });
    }
    if (context === "input") {
      return /*#__PURE__*/jsx(InputContainer, {
        ...props
      });
    } else {
      return /*#__PURE__*/jsx(FacitContainer, {
        ...props
      });
    }
  })();
  return /*#__PURE__*/jsx(MaximumDropzoneTextLength.Provider, {
    value: maximumDropzoneTextLength,
    children: /*#__PURE__*/jsx(MaximumTileTextLength.Provider, {
      value: maximumTileTextLength,
      children: content
    })
  });
}

export { GroupTask };
//# sourceMappingURL=_task.group.js.map
